module.exports = __webpack_public_path__ + "static/media/gadzety_kreatywne_01_C.05d3f575.png";